import React from 'react';
import { Carousel } from '../Carousel';
import { Image as FiImage } from '../Image';
import { getFiGrowthBook } from '../../lib/growthbook';
import { Species } from '../../types/gql-op-types';
import type { PickYourFiDeviceKey } from './HardwareFirstBelowFold';
import styles from './HardwareFirstAppCarousel.module.scss';

const S3_APP_SCREENS = [
  '/product_images/smart-collar-v3b/app-ui-homescreen-1-dog.png',
  '/product_images/smart-collar-v3b/app-ui-homescreen-2-dog.png',
  '/product_images/smart-collar-v3b/app-ui-homescreen-3-dog.png',
];

const ULTRA_APP_SCREENS = [
  '/product_images/ultra/app-ui-homescreen-1.png',
  '/product_images/ultra/app-ui-homescreen-2.png',
];

const CAT_APP_SCREENS = ['/product_images/smart-collar-v3b/app-ui-homescreen-1-cat.png'];

/**
 * The app screenshots below the fold, one treatment for all three devices. Mini and series 3+ share
 * a screen set - the shots are of the app, not the tracker - and the extra two are the behavior
 * screens the `ecom-mini-behavior` experiment gates on the mini pdp. Cats get the cat home screen,
 * and none of the behavior shots, which read dog activity.
 */
export default function HardwareFirstAppCarousel({
  deviceKey,
  species = Species.DOG,
}: {
  deviceKey: PickYourFiDeviceKey;
  species?: Species;
}) {
  const behaviorScreens = getFiGrowthBook().getFeatureValue<boolean>('ecom-mini-behavior', false);
  let images = S3_APP_SCREENS.slice(0, behaviorScreens ? S3_APP_SCREENS.length : 1);
  if (species === Species.CAT) {
    images = CAT_APP_SCREENS;
  } else if (deviceKey === 'ultra') {
    images = ULTRA_APP_SCREENS;
  }

  return (
    <Carousel className={styles.carousel} wrapAround prevNextButtons={images.length > 1}>
      {images.map((url) => (
        <div key={url} className={styles.image}>
          <FiImage image={{ type: 'image', url, descriptors: ['1000w'] }} loading="eager" />
        </div>
      ))}
    </Carousel>
  );
}
